import * as THREE from 'three'

// UV wrap policy: treat UVs outside 0–1 as tiled repeats of the same image,
// matching how DCC tools (Maya/Blender/Substance) display out-of-range UVs.
// Myra's MetaHuman body meshes carry islands in UDIM tile 1002 (U 1–2); the
// three.js default of ClampToEdgeWrapping clamps those to the texture edge and
// smears one column across the whole mesh. RepeatWrapping samples frac(uv), so
// a mesh whose islands sit in a single non-1001 tile maps correctly onto the
// one 0–1 image, and out-of-range UVs in general tile instead of smearing.
//
// (A mesh that genuinely SPANS two tiles still needs per-tile textures or a UV
// repack; this fixes the common single-shifted-tile / slightly-out-of-range
// cases and never regresses in-range UVs — avatar islands sit within
// [0.003, 0.997], clear of the exact 0/1 seam where wrap vs clamp differ.)
//
// Pure + dependency-light (THREE only) so it's unit-testable without the full
// avatarMaterial import chain. Applied at every texture-creation site in
// avatarMaterial (KTX2, plain, and inherited by cloned textures).
export function applyDefaultTextureWrap(tex) {
  if (!tex) return tex
  tex.wrapS = THREE.RepeatWrapping
  tex.wrapT = THREE.RepeatWrapping
  return tex
}
